<mat-spinner *ngIf="show" [diameter]="diameter" color="primary"></mat-spinner>
